module.exports = __webpack_public_path__ + "img/faq-illustrations.a8bd60c0.svg";